import React from "react";
import { Spinner } from "reactstrap";

const Loading = ({ height }) => {
  return (
    <div
      className="d-flex justify-content-center  align-items-center"
      style={{ height: height !== undefined ? "20px" : "100vh" }}
    >
      <Spinner
        style={{ color: "rgba(128, 118, 103, 0.7)" }}
        type="grow"
      ></Spinner>
    </div>
  );
};

export const GraphLoader = () => {
  return (
    <div className="w-100 text-center">
      <div className="ph-item p-0 border-none">
        <div className="ph-col-6 mb-0 ps-0">
          <div className="ph-picture graph-loader-tiles shadow" />
        </div>
        <div className="ph-col-6 mb-0 pe-0">
          <div className="ph-picture graph-loader-tiles shadow" />
        </div>
      </div>
    </div>
  );
};

export default Loading;
